import deleteIcon from 'assets/icons/deleteIcon.svg';
import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Skeleton } from 'primereact/skeleton';
import { getRoundedValueForMarketShare } from 'utils/computation';
import classes from './TmsStrategiesResolveErrorsModal.module.scss';
import { useMarketHistoryValues } from './useTmsStrategiesResolveErrorsModal';
import { Dialog } from 'primereact/dialog';

const TmsStrategiesResolveErrorsModal = ({
  gfc,
  sellingCategory,
  cot,
  visiblility,
  toggleVisibility,
}: {
  gfc: number;
  sellingCategory: string;
  cot: string;
  visiblility: boolean;
  toggleVisibility: () => void;
}) => {
  const {
    columnDetails,
    tmsStrategiesData,
    isTmsStrategiesDataLoading,
    checkIfCurrentRowIsBeingDelete,
    handleDeleteFutureTms,
    checkIfFunctionalityEnabled,
    userModulesRoles,
    tmsAllowRoles,
  } = useMarketHistoryValues(gfc, sellingCategory, cot);
  return (
    <Dialog
      blockScroll
      resizable={false}
      draggable={false}
      headerClassName={classes.modalHeader}
      header={`TMS Strategies`}
      visible={visiblility}
      style={{ width: '30vw' }}
      onHide={toggleVisibility}
    >
      <div className={classes.marketHistoricalValuesContainer}>
        {isTmsStrategiesDataLoading ? (
          <Skeleton height="10rem" style={{ width: '100%' }} />
        ) : (
          <div className={classes.tablesContainer}>
            {/* <Player autoplay keepLastFrame className={classes.lottiePlayer} src={successAnimation} /> */}
            <div className={classes.tablesContainerInstance}>
              <div className={classes.tableHeading}>Future TMS</div>
              <table className={classes.datatable}>
                <thead>
                  <tr>
                    {columnDetails.map((column, index) => {
                      return <th key={index}>{column.label}</th>;
                    })}
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {tmsStrategiesData.future_tms_values.map((row, index) => {
                    return (
                      <tr key={index}>
                        <td>{parseInt((parseFloat(row.TargetMarketShare) * 100).toString())}</td>
                        <td>{row.TMSStrategyID.TMSStrategyCode}</td>
                        <td>{row.StartDate} </td>
                        <td>{row.EndDate}</td>
                        <td>
                          {!checkIfCurrentRowIsBeingDelete(row.MarketShareID as number) ? (
                            <Button
                              onClick={() => handleDeleteFutureTms(row.MarketShareID as number)}
                              className={classes.deleteIconButton}
                              icon={<img src={deleteIcon} alt="delete" />}
                              rounded
                              text
                              aria-label="delete"
                              disabled={
                                !checkIfFunctionalityEnabled(
                                  tmsAllowRoles.tmsModalFutureHistoryDeleteButton,
                                  userModulesRoles.facts,
                                  userModulesRoles
                                )
                              }
                            />
                          ) : (
                            <ProgressSpinner
                              style={{ width: '25px', height: '25px' }}
                              strokeWidth="8"
                              fill="var(--surface-ground)"
                              animationDuration="1s"
                            />
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className={classes.tablesContainerInstance}>
              <div className={classes.tableHeading}>Past TMS</div>
              <table className={classes.datatable}>
                <thead>
                  <tr>
                    {columnDetails.map((column, index) => {
                      return <th key={index}>{column.label}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {tmsStrategiesData.past_tms_values.map((row, index) => {
                    return (
                      <tr key={index}>
                        <td>{getRoundedValueForMarketShare(row.TargetMarketShare)}</td>
                        <td>{row.TMSStrategyID.TMSStrategyCode}</td>
                        <td>{row.StartDate} </td>
                        <td>{row.EndDate}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default observer(TmsStrategiesResolveErrorsModal);
